import React from 'react';
import { useNavigate } from 'react-router-dom';

function Connect({ onPlayConnect }) {
  const navigate = useNavigate();

  const handleActualConnect = () => {
    const clientId = 'Ov23liPUmhP9rLqLlflp';
    const redirectUri = 'https://staging.bonzai.dev/api/auth/callback';
    const scope = 'repo read:user';
    const state = encodeURIComponent(window.location.origin); // Pass origin to redirect back after auth
    const githubAuthUrl = `https://github.com/login/oauth/authorize?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scope)}&state=${state}`;
    window.location.href = githubAuthUrl;
  };

  const handleViewDemo = () => {
    if (onPlayConnect) {
      onPlayConnect();
    } else {
      navigate('/audit');
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#fff',
      fontFamily: "'Space Grotesk', -apple-system, BlinkMacSystemFont, sans-serif"
    }}>
      <link href="https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500;600&display=swap" rel="stylesheet" />

      <div style={{
        width: 48,
        height: 48,
        borderRadius: 10,
        background: 'linear-gradient(135deg, #FF6B35 0%, #FF3D00 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 24,
        fontWeight: 700,
        color: '#fff',
        marginBottom: 24
      }}>
        B
      </div>

      <h1 style={{
        fontSize: 28,
        fontWeight: 700,
        color: '#1a1a1a',
        marginBottom: 12,
        letterSpacing: -0.5
      }}>
        GitHub Workflow Audit
      </h1>

      <p style={{
        fontSize: 14,
        color: '#666',
        marginBottom: 32,
        fontFamily: "'JetBrains Mono', monospace",
        textAlign: 'center',
        maxWidth: 400,
        lineHeight: 1.6
      }}>
        Connect your repo to see code churn, PR metrics, and estimated cost of rework in the age of AI.
      </p>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        alignItems: 'center'
      }}>
        <button
          onClick={handleActualConnect}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '14px 28px',
            fontSize: 16,
            fontWeight: 600,
            color: '#fff',
            background: '#24292e',
            border: 'none',
            borderRadius: 8,
            cursor: 'pointer',
            transition: 'background 0.2s',
            width: 220,
            justifyContent: 'center'
          }}
          onMouseOver={(e) => e.currentTarget.style.background = '#2f363d'}
          onMouseOut={(e) => e.currentTarget.style.background = '#24292e'}
        >
          <svg height="20" viewBox="0 0 16 16" width="20" fill="#fff">
            <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"/>
          </svg>
          Connect to GitHub
        </button>

        <button
          onClick={handleViewDemo}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '12px 28px',
            fontSize: 14,
            fontWeight: 500,
            color: '#6b7280',
            background: '#f3f4f6',
            border: '1px solid #e5e7eb',
            borderRadius: 8,
            cursor: 'pointer',
            transition: 'all 0.2s',
            width: 220,
            justifyContent: 'center'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.background = '#e5e7eb';
            e.currentTarget.style.color = '#374151';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.background = '#f3f4f6';
            e.currentTarget.style.color = '#6b7280';
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="5 3 19 12 5 21 5 3"/>
          </svg>
          View Demo
        </button>
      </div>

      <p style={{
        fontSize: 11,
        color: '#999',
        marginTop: 24,
        fontFamily: "'JetBrains Mono', monospace"
      }}>
        Read-only access · No source code stored
      </p>
    </div>
  );
}

export default Connect;
